import script from "./SeriesSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./SeriesSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./SeriesSwitcher.vue?vue&type=style&index=0&id=06294742&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06294742"]])

export default __exports__